module.exports = __webpack_public_path__ + "static/media/PhoneShell.3a900fd1.svg";